// Samajh Design System v5
// Rules: green=logo+CTA only, gold=streak only, slate-based text, cool shadows
export const API_BASE = "https://api.samajhapp.com";

// ── Corrected text tokens ──
export const TEXT = {
  primary: "#0F172A",
  secondary: "#475569",
  muted: "#94A3B8",
  inactive: "#64748B",
};

// ── Accent tokens ──
export const ACCENT = {
  green: "#1A7A52",
  blue: "#5FA4C4",
  gold: "#E8A817",
};

// ── Card tokens ──
export const CARD = {
  bg: "#FFFFFF",
  support: "#F8FBFD",
  border: "1px solid rgba(140,110,60,0.08)",
  shadow: "0 2px 8px rgba(140,110,60,0.08), 0 1px 2px rgba(140,110,60,0.06)",
  shadowSubtle: "0 2px 6px rgba(140,110,60,0.06)",
  shadowNav: "0 -2px 10px rgba(140,110,60,0.05)",
};

export const R = { sm: 10, md: 14, lg: 18 };

export const SUBJECT_COLORS = {
  Maths:      { c: "#D4880A", bg: "#FFF5E0", light: "#FFF6E8", border: "#F0D498" },
  Science:    { c: "#10B981", bg: "#E8F5EE", light: "#E6FAF2", border: "#90DCC0" },
  Geography:  { c: "#3B82F6", bg: "#EBF2FF", light: "#EBF2FF", border: "#A0C4F8" },
  Economics:  { c: "#8B5CF6", bg: "#F0E8FF", light: "#F0EAFF", border: "#C4B0F0" },
  History:    { c: "#E85D3A", bg: "rgba(232,93,58,0.08)", light: "#FFF0EB", border: "#F0B8A0" },
  Civics:     { c: "#5A7090", bg: "rgba(90,112,144,0.08)", light: "#EEF2FA", border: "#B0C0D8" },
};

export const TAB_GRADIENTS = {
  // GRADIENT-ZONE-SHIFT-APPLIED: WebView-compensated saturated top + mid-screen fade to pale zone for section separation
  study:    "linear-gradient(180deg, #2E9ECE 0%, #38A8D8 8%, #4AABDB 18%, #5FBDE5 30%, #8DD2EF 42%, #D4EEF8 52%, #E8F4FA 60%, #E8F4FA 100%)",
  practice: "linear-gradient(180deg, #5AAA9A 0%, #78C4B8 15%, #9AD8CC 30%, #B8E6DC 45%, #D0EEE8 60%, #E4F5F0 75%, #F0FAF7 90%, #F7FBFA 100%)",
  revise:   "linear-gradient(180deg, #8A8AC8 0%, #A0A0DA 15%, #B8B8E6 30%, #D0D0EE 45%, #DFE0F4 60%, #ECEDF8 75%, #F4F4FB 90%, #FAFAFD 100%)",
};

export const TAB_NAV = {
  study:    "linear-gradient(180deg, #7EB3D4, #6BA5C8)",
  practice: "linear-gradient(180deg, #6AB8A8, #5AA898)",
  revise:   "linear-gradient(180deg, #8888B8, #7878A8)",
};

// ── Legacy C object (used by TutorApp, ExplainPage, etc.) ──
export const C = {
  action: "#1A7A52", actionLight: "#E8F5EE",
  streak: "#E8A817", streakDark: "#7A5200", streakBg: "rgba(232,168,23,0.08)",
  indigo: "#1E2A4A", indigoLight: "#2A3A5A",
  continueBg: "rgba(255,244,232,0.95)",
  cardBg: "#FFFFFF", cardBorder: "rgba(140,110,60,0.08)",
  cardShadow: "0 2px 8px rgba(140,110,60,0.08), 0 1px 2px rgba(140,110,60,0.06)",
  cardShadowLg: "0 4px 16px rgba(140,110,60,0.12), 0 2px 4px rgba(140,110,60,0.06)",
  border: "rgba(140,110,60,0.08)", borderMd: "rgba(140,110,60,0.12)", borderStrong: "#D0C8B0",
  borderLight: "rgba(140,110,60,0.06)",
  surface: "#F8FBFD", surfaceCream: "#FFF4E8",
  dark: "#0F172A", text: "#0F172A", textMid: "#475569", textMute: "#94A3B8", textCaption: "#94A3B8",
  toggleBg: "rgba(140,110,60,0.06)", toggleInactive: "#64748B",
  tickerBg: "rgba(242,232,200,0.6)", tickerBorder: "rgba(220,200,160,0.3)", tickerText: "#5A4A30",
  emptyProgress: "#E8EEF3", emptyDot: "rgba(140,110,60,0.08)",
  bitesBg: "linear-gradient(145deg, #0F0F14 0%, #1A1A28 50%, #12121A 100%)",
  primary: "#0d9488", primaryDark: "#0f766e", primaryMid: "#0F6E56",
  primaryMuted: "#085041", primaryDeep: "#04342C", primaryLight: "#9FE1CB",
  primarySoft: "#E1F5EE", primarySoftBorder: "#9FE1CB",
  amber: "#EF9F27", amberDark: "#854F0B", amberSoft: "#FAEEDA", amberBorder: "#FAC775", amberMid: "#BA7517",
  bg: "#ffffff", shadow: "0 2px 8px rgba(140,110,60,0.08)", shadowMd: "0 4px 12px rgba(140,110,60,0.10)",
  ink: "#0f172a",
  userBubble: "#E1F5EE", userBubbleText: "#04342C", userBubbleBorder: "0.5px solid #9FE1CB",
};

export const getFontFamily = (lang) =>
  lang === "hi" ? "'Noto Sans Devanagari','Poppins',sans-serif" : "'Poppins',sans-serif";
